// extracted by mini-css-extract-plugin
module.exports = {"exampleWrapper":"launchpadExample_exampleWrapper__3xFfA","exampleDetails":"launchpadExample_exampleDetails__36S_G"};